import React, { Component } from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import swal from 'sweetalert';

const allowedRegex = /^[a-zA-Z0-9\-\_\(\)\.\s]*$/;
class ModalDatosComerciales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: props.data ? {
                nombreComercial: props.data.nombre,
                idCliente: props.data.cliente_id,
                numeroCuenta: props.data.cuenta_nro,
                claveInterbancaria: props.data.clave_interbancaria,
            } : {
                nombreComercial: '',
                idCliente: '',
                numeroCuenta: '',
                claveInterbancaria: '',
            },
            errors: {
                nombreComercial: false,
                idCliente: false,
                numeroCuenta: false,
                claveInterbancaria: false,
            }
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && (!prevProps.show || prevProps.data !== this.props.data)) {
            this.setState({
                form: this.props.data || {
                    nombreComercial: '',
                    idCliente: '',
                    numeroCuenta: '',
                    claveInterbancaria: '',
                },
                errors: {
                    nombreComercial: false,
                    idCliente: false,
                    numeroCuenta: false,
                    claveInterbancaria: false,
                }
            });
        }
    }

    validateField = (name, value) => {
        return !allowedRegex.test(value);
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        const isInvalid = this.validateField(name, value);
        this.setState(prevState => ({
            form: { ...prevState.form, [name]: value },
            errors: { ...prevState.errors, [name]: isInvalid }
        }));
    };

    isAnyFieldInvalid = () => {
        return Object.values(this.state.errors).some(Boolean);
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.isAnyFieldInvalid()) return;

        const { gerenciadorId, onSave, onClose, ajaxHandler, data } = this.props;
        const { form } = this.state;

        const hasAnyValue = form.nombreComercial || form.idCliente || form.numeroCuenta || form.claveInterbancaria;
        if (!hasAnyValue) {
            swal({
                title: this.props.intl.formatMessage({
                    id: 'modalDatosComerciales.form.validation.at_least_one',
                    defaultMessage: 'Debe completar al menos un campo para guardar.'
                }),
                icon: "warning",
                button: {
                    text: this.props.intl.formatMessage({ id: 'modalDatosComerciales.form.button.accept', defaultMessage: 'Aceptar' }),
                    className: "btn btn-primary"
                }
            });
            return;
        }

        const payload = {
            nombre: form.nombreComercial,
            cliente_id: form.idCliente,
            cuenta_nro: form.numeroCuenta,
            clave_interbancaria: form.claveInterbancaria,
        };

        const isEdit = data && data.id;
        const url = isEdit
            ? `/gerenciadores/${gerenciadorId}/datos-bancarios/${data.id}`
            : `/gerenciadores/${gerenciadorId}/datos-bancarios`;

        ajaxHandler.fetch(url, {
            method: isEdit ? 'PUT' : 'POST',
            body: JSON.stringify(payload),
        })
            .then(response => {
                if (response.ok || response.status === 200 || response.status === 201) {
                    return response.json();
                } else {
                    alert('Error al guardar los datos bancarios');
                    return null;
                }
            })
            .then(data => {
                if (data && onSave) onSave(data);
                if (onClose) onClose();
            })
            .catch(() => {
                alert('Error de red al guardar los datos bancarios');
            });
    };

    renderInput = (name, labelId, defaultMessage) => {
        const { form, errors } = this.state;
        return (
            <div className="form-group row">
                <label className="col-md-5 label-control col-form-label" htmlFor={name}>
                    {this.props.intl.formatMessage({ id: labelId, defaultMessage })}:
                </label>
                <div className="col-md-7">
                    <input
                        className={`form-control${errors[name] ? ' is-invalid' : ''}`}
                        id={name}
                        name={name}
                        value={form[name]}
                        onChange={this.handleChange}
                        required
                        autoComplete="off"
                        title={errors[name] ? this.props.intl.formatMessage({
                            id: 'modalDatosComerciales.form.validation.invalid_characters',
                            defaultMessage: 'Solo se permiten letras, números, guion medio, guion bajo, paréntesis y puntos.'
                        }) : ''}
                    />
                    {errors[name] && (
                        <div className="invalid-feedback" style={{ display: 'block' }}>
                            {this.props.intl.formatMessage({
                                id: 'modalDatosComerciales.form.validation.invalid_characters',
                                defaultMessage: 'Solo se permiten letras, números, guion medio, guion bajo, paréntesis y puntos.'
                            })}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    render() {
        if (!this.props.show) return null;

        const { form } = this.state;

        return (
            <>
                <div
                    className="modal fade show"
                    id="modal_datos_comerciales"
                    role="dialog"
                    aria-labelledby="modalDatosComercialesLabel"
                    aria-modal="true"
                    style={{ display: 'block', zIndex: 1051 }}
                >
                    <div className="modal-xl modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header bg-fleet">
                                <h4 className="modal-title text-white" id="modalDatosComercialesLabel">
                                    <i className="la la-plus align-middle icon-modal-title"></i>
                                    {
                                        this.props.data
                                        ? this.props.intl.formatMessage({ id: 'modalDatosComerciales.modal_title.editar', defaultMessage: 'Editar dato comercial/bancario' })
                                        : this.props.intl.formatMessage({ id: 'modalDatosComerciales.modal_title.nuevo', defaultMessage: 'Nuevo dato comercial/bancario' })
                                    }
                                </h4>
                                <button
                                    type="button"
                                    className="close"
                                    aria-label="Close"
                                    onClick={this.props.onClose}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body modal-grey modal-mh ovf-x-hidden">
                                <div
                                    className="card pull-up"
                                    style={{
                                        margin: 0,
                                        borderRadius: 6,
                                        borderLeft: '5px solid #00c0bd',
                                        boxShadow: 'none'
                                    }}
                                >
                                    <div 
                                        className="card-content"
                                        style={{ paddingTop: '1rem' }}
                                    >
                                        <div className="card-body">
                                            <h4 className="form-section" style={{ color: '#00c0bd', fontWeight: 500 }}>
                                                <i className="ft-credit-card"></i> {this.props.intl.formatMessage({ id: 'modalDatosComerciales.form.title', defaultMessage: 'Datos Comerciales y Bancarios' })}
                                            </h4>
                                            <hr style={{
                                                marginTop: '5px',
                                                marginBottom: '20px',
                                                lineHeight: '3rem',
                                                borderTop: '2px solid #6b6f82'
                                            }} />
                                            <form onSubmit={this.handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        {this.renderInput('nombreComercial', 'modalDatosComerciales.form.commercial_name', 'Nombre Comercial')}
                                                    </div>
                                                    <div className="col-md-6">
                                                        {this.renderInput('idCliente', 'modalDatosComerciales.form.client_id', 'ID Cliente')}
                                                    </div>
                                                    <div className="col-md-6">
                                                        {this.renderInput('numeroCuenta', 'modalDatosComerciales.form.account_number', 'Número de Cuenta')}
                                                    </div>
                                                    <div className="col-md-6">
                                                        {this.renderInput('claveInterbancaria', 'modalDatosComerciales.form.interbank_key', 'Clave Interbancaria')}
                                                    </div>
                                                    <div className="col-md-6"></div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="card pull-up"
                                    style={{
                                        marginTop: 24,
                                        borderRadius: 6,
                                        borderLeft: '5px solid #00c0bd',
                                        boxShadow: 'none'
                                    }}
                                >
                                    <div className="card-content">
                                        <div className="card-body d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-fleet"
                                                onClick={this.handleSubmit}
                                                disabled={this.isAnyFieldInvalid()}
                                            >
                                                <i className="fa fa-check-circle"></i> <FormattedMessage id="modalDatosComerciales.form.button.save" defaultMessage="Guardar"/>
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-danger ml-2"
                                                onClick={this.props.onClose}
                                            >
                                                <i className="fa fa-times-circle"></i> <FormattedMessage id="modalDatosComerciales.form.button.cancel" defaultMessage="Cancelar"/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
            </>
        );
    }
}

export default injectIntl(ModalDatosComerciales);